import type { ReactNode } from "react";

export function Eyebrow({ children }: { children: ReactNode }) {
  return (
    <p className="font-mono text-[10px] tracking-[0.18em] uppercase text-ink-muted">
      {children}
    </p>
  );
}
